/* eslint-disable complexity */
import qs from "query-string";
import { ORDER_STATUS } from "../../constants/checkout-constants";
import { EXPERIMENT_TYPE } from "../../constants/optimize-constants";
// import isTestDriveEnabledState from "./is-test-drive-enabled-state";
import { FILTER_KEYS } from "../../constants/app-constants";
import getCarInfo from "./get-car-info";

export const getAbExpirementVariant = (key = {}, variant = "VARIANT_A") => (key && key.data === EXPERIMENT_TYPE[variant]) || false;

export const isExperimentNull = (value) => (!EXPERIMENT_TYPE.hasOwnProperty(value)) || false;

export const showTestDriveVariant = ({ order = {}, content = {}, orderStatus = "" }) => {
    const { status = "" } = order || {};
    const { showTDCta = false } = getCarInfo(content) || {};
    const { reserved, booked, displayTestDriveFlow, carCategory } = content || {};
    let showTdfViaQuery = false;
    if (typeof window !== "undefined") {
        const queryParams = qs.parse(window.location.search);
        showTdfViaQuery = (queryParams || {}).tdf === "true";//tdf => testdriveflow
    }
    const isEnabled = (showTdfViaQuery) &&
        (!booked) && !reserved &&
        showTDCta &&
        (carCategory === FILTER_KEYS.CARS24 || carCategory === FILTER_KEYS.CARS24_LUXE || carCategory === FILTER_KEYS.CARS24_SELECT) &&
        (status || orderStatus) !== ORDER_STATUS.TEST_DRIVE_RESERVED &&
        (status || orderStatus) !== ORDER_STATUS.RESERVED &&
        (displayTestDriveFlow);
    return isEnabled;
};

export const showNewTestDriveVariant = ({
    // order = {},
    content = {}
    // orderStatus = "",
    // userState,
    // countryCode,
    // isTestDriveEnabledForIndia,
    // eligibleStateNames = [],
    // comingSoonExperiment
}) => {
    // const { status = "", testDriveStatus } = order || {};
    const { showTDCta = false } = getCarInfo(content) || {};
    // const { reserved, comingSoon, booked, state, listingActive, carCategory } = content || {};
    // const isTestDriveEnabledForIndiaFlag = countryCode === "IN" && isTestDriveEnabledForIndia;
    // const isComingSoonVariantB = getAbExpirementVariant(comingSoonExperiment, EXPERIMENT_TYPE.VARIANT_B);
    // const isComingSoonEligible = comingSoon ? isComingSoonVariantB : true;
    // const isEnabled =
    //     !booked &&
    //     isComingSoonEligible &&
    //     !reserved &&
    //     listingActive &&
    //     testDriveStatus !== ORDER_STATUS.TEST_DRIVE_COMPLETED &&
    //     (carCategory === FILTER_KEYS.CARS24 || carCategory === FILTER_KEYS.CARS24_LUXE || carCategory === FILTER_KEYS.CARS24_SELECT) &&
    //     isTestDriveEnabledState({ state, userState, isTestDriveEnabledForIndiaFlag, eligibleStateNames }) &&
    //     (status || orderStatus) !== ORDER_STATUS.RESERVED;

    return showTDCta;
};

export const showPostWarrantyVariant = (showWarrantyPageShift) => {
    const { data: showWarrantyPageShiftData = "VARIANT_B" } = showWarrantyPageShift || {};
    const showPostWarrantyPage = showWarrantyPageShiftData !== EXPERIMENT_TYPE.VARIANT_B;
    return showPostWarrantyPage;
};

export const getFinanceDiscoveryVariant = ({ queryParams: params = {}, preApproved = false, showFinanceCentricListing = false }) => {
    const { fc = false } = params || {};
    const financeDiscoveryVariant = "VARIANT_B";

    const isFinanceDiscoveryVariant = !preApproved;
    const isFinanceDiscoveryLayout = fc || showFinanceCentricListing;
    return { isFinanceDiscoveryVariant, isFinanceDiscoveryLayout, financeDiscoveryVariant };
};

export const checkActiveExperimentVariants = (key = {}, experimentTypes = []) => {
    return experimentTypes.some(variant => getAbExpirementVariant(key, variant));
};

export const getCityEligibility = (cityCode, eligibleCities = []) => {
    if (!cityCode || !Array.isArray(eligibleCities) || eligibleCities.length === 0) return false;
    const target = String(cityCode).trim().toLowerCase();
    return eligibleCities.some(c => String(c).trim().toLowerCase() === target);
};
